/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { useRef } from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import Label from "../../components/label";
import ICDateInput from "../../components/form/dateInput";
import ICSelect from "../../components/form/selectInput";
import DefaultUserImg from "../../assets/images/default-picture.png";
import NoImg from "../../assets/images/no-img.png";
import moment from "moment";
import { signUpProfilePicUpload } from "../../apiRoutes";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputMask from "react-input-mask";

const DoctorSignUp = props => {
  // For profile picture
  const inputUserProfilePic = useRef(null);
  const [userProfilePic, setuserProfilePic] = React.useState(null);
  const [userPicLoader, setUserPicLoader] = React.useState(false);

  // let signUpBtnDisable = props.userSubscribed && props.userSubscribed.oneSignalSubscribed.isSubscribed ? false : true;
  let signUpBtnDisable = false;

  // For Photo ID
  const inputPhotoId = useRef(null);
  const [userPhotoId, setuserPhotoId] = React.useState(null);
  const [userPhotoIdLoader, setUserPhotoIdLoader] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      confirmEmailId: "",
      phoneNumber: "",
      streetNumber: "",
      streetName: "",
      suburb: "",
      postCode: "",
      photoId: "",
      photoIdThumb: "",
      profilePic: "",
      profilePicThumb: "",
      password: "",
      confirmPassword: "",
      gender: "Select Gender",
      state: "Select State",
      isFile: false,
      deviceType: 2,
      appVersion: 100,
      deviceToken:  props.userSubscribed && props.userSubscribed.oneSignalSubscribed.oneSignalId ? props.userSubscribed.oneSignalSubscribed.oneSignalId : "" ,
      dateOfBirth: ""
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please enter the First Name"),
      lastName: Yup.string().required("Please enter the Last Name"),
      gender: Yup.string()
        .notOneOf(["Select Gender"])
        .required("Please select Gender"),
      dateOfBirth: Yup.string().required("Please select date of birth"),
      state: Yup.string()
        .notOneOf(["Select State"])
        .required("Please select the State"),
      email: Yup.string()
        .email("Invalid email")
        .required("Please enter the Email Address"),
      confirmEmailId: Yup.string()
        .email("Invalid email")
        .oneOf([Yup.ref("email")], "Both Email IDs should match")
        .required("Please confirm Email Address"),
      phoneNumber: Yup.string()
                  .matches(/([0-9]{4}\s[0-9]{3}\s[0-9]{3})/, 'Please enter correct Mobile Number')
                  .required("Please enter the Mobile Number"),
      streetNumber: Yup.string().required("Please enter Unit/Street Number"),
      streetName: Yup.string().required("Please enter Street Name"),
      suburb: Yup.string().required("Please enter Suburb"),
      postCode: Yup.string()
      .matches(/([0-9]{4})/, 'Please enter correct Postcode')
      .required("Please enter Postcode"),
      password: Yup.string()
        .min(
          14,
          "Password should be at least 14 and maximum 20 characters long and should contain one number, one special character, one uppercase and one lowercase"
        )
        .matches(/^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])(?=.*[a-z])[A-Za-z\d$@$!%*#?&]{14,20}$/, "Password should be at least 14 and maximum 20 characters long and should contain one number, one special character, one uppercase and one lowercase")
        .required("Please enter the password"),
      confirmPassword: Yup.string()
        .min(
          14,
          "Password should be at least 14 and maximum 20 characters long and should contain one number, one special character, one uppercase and one lowercase"
        )
        .required("Please enter the confirm password")
        .oneOf([Yup.ref("password")], "Both Passwords should match")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });

  // For Profile Pic input
  const handleFileInput = () => {
    inputUserProfilePic.current.click();
  };

  const onChangeHandler = event => {
    if (event.target.files && event.target.files[0]) {
      // Check the file size is 1MB or less
      if (event.target.files[0].size > 1_048_576){
        props.errorFileUpload({ message: "Please select an image that is 1MB or less" });
        return;
      }

      if (
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/gif" ||
        event.target.files[0].type === "image/jpeg" ||
        event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/svg"
      ) {
        setUserPicLoader(true);
        const bodyData = new FormData();
        bodyData.append("profilePic", event.target.files[0]);

        let apiCallParam = {
          reqType: "POST",
          reqURL: signUpProfilePicUpload,
          dataObj: bodyData,
          params: {},
          headers: {},
          successCallback: res => {
            setUserPicLoader(false);
            setuserProfilePic(res.data.data.original);
            formik.values.profilePicThumb = res.data.data.thumb;
            formik.values.profilePic = res.data.data.original;
            formik.values.isFile = true;
          },
          failureCallback: err => {
            setUserPicLoader(false);
            props.errorFileUpload(err);
          },
          showPopUp: false
        };

        props.fileUploadRequest(apiCallParam);
      } else {
        props.errorFileUpload({ message: "Please select image file" });
      }
    }
  };

  // For Photo ID input
  const handlePhotoIDFileInput = () => {
    inputPhotoId.current.click();
  };

  const onChangePhotoIDHandler = event => {
    if (event.target.files && event.target.files[0]) {
      if (
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/gif" ||
        event.target.files[0].type === "image/jpeg" ||
        event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/svg"
      ) {
        setUserPhotoIdLoader(true);
        const bodyData = new FormData();
        bodyData.append("profilePic", event.target.files[0]);
        let apiCallParam = {
          reqType: "POST",
          reqURL: signUpProfilePicUpload,
          dataObj: bodyData,
          params: {},
          headers: {},
          successCallback: res => {
            setuserPhotoId(res.data.data.original);
            setUserPhotoIdLoader(false);
            formik.values.photoIdThumb = res.data.data.thumb;
            formik.values.photoId = res.data.data.original;
            formik.values.isFile = true;
          },
          failureCallback: err => {
            setUserPhotoIdLoader(false);
            props.errorFileUpload(err);
          },
          showPopUp: false
        };
        props.fileUploadRequest(apiCallParam);
      } else {
        props.errorFileUpload({ message: "Please select image file" });
      }
    }
  };

  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <div className="row p-4">
        <Label className="gray large ml-3 w-100" title="Basic Information" />
        <div className="col-sm-4">
          <Label className="gray small" title="First Name" required={true} />
          <ICInput
            id="firstName"
            name="firstName"
            label=""
            placeholder="First"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.firstName}
            error={
              formik.touched.firstName && formik.errors.firstName ? true : false
            }
            helperText={
              formik.touched.firstName && formik.errors.firstName
                ? formik.errors.firstName
                : ""
            }
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Middle Name" />
          <ICInput
            id="middleName"
            name="middleName"
            label=""
            placeholder="Middle"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.middleName}
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Last Name" required={true} />
          <ICInput
            id="lastName"
            name="lastName"
            label=""
            placeholder="Last"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.lastName}
            error={
              formik.touched.lastName && formik.errors.lastName ? true : false
            }
            helperText={
              formik.touched.lastName && formik.errors.lastName
                ? formik.errors.lastName
                : ""
            }
          />
        </div>

        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="Date of Birth" required={true} />
          <ICDateInput
            id="dateOfBirth"
            name="dateOfBirth"
            className="cal-primary-bg pt-6"
            label=""
            defaultDate={false}
            handleChange={val => {
              formik.values.dateOfBirth = val;
              formik.setFieldValue(
                "dateOfBirth",
                moment(val).format("DD-MM-YYYY")
              );
              formik.handleChange("dateOfBirth");
            }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.dateOfBirth}
            error={
              formik.touched.dateOfBirth && formik.errors.dateOfBirth
                ? true
                : false
            }
            helperText={
              formik.touched.dateOfBirth && formik.errors.dateOfBirth
                ? formik.errors.dateOfBirth
                : ""
            }
          />
          {formik.errors.dateOfBirth && formik.touched.dateOfBirth ? (
            <Label
              title="Please select Date of Birth"
              className="small error"
            />
          ) : (
            ""
          )}
        </div>

        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="Gender" required={true} />
          <ICSelect
            label=""
            placeholder="Select Gender"
            id="gender"
            name="gender"
            useId="_id"
            useValue="val"
            items={[
              { _id: "Male", val: "Male" },
              { _id: "Female", val: "Female" }
            ]}
            value={formik.values.gender}
            onBlur={formik.handleBlur}
            handleChange={val => {
              formik.values.gender = val;
              formik.setFieldValue("gender", val);
              formik.handleChange("gender");
            }}
            error={formik.touched.gender && formik.errors.gender ? true : false}
            helperText={
              formik.touched.gender && formik.errors.gender
                ? formik.errors.gender
                : ""
            }
          />
          {formik.errors.gender && formik.touched.gender ? (
            <Label title="Please select Gender" className="small error" />
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="row mt-1 p-4">
        <Label className="gray large ml-3 w-100" title="Contact Information" />

        <div className="col-sm-6">
          <Label className="gray small" title="Email Address" required={true} />
          <ICInput
            id="email"
            name="email"
            label=""
            placeholder="Email Address"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            error={formik.touched.email && formik.errors.email ? true : false}
            helperText={
              formik.touched.email && formik.errors.email
                ? formik.errors.email
                : ""
            }
          />
        </div>
        <div className="col-sm-6">
          <Label
            className="gray small"
            title="Confirm Email Address"
            required={true}
          />
          <ICInput
            id="confirmEmailId"
            name="confirmEmailId"
            label=""
            placeholder="Confirm Email Address"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirmEmailId}
            error={
              formik.touched.confirmEmailId && formik.errors.confirmEmailId
                ? true
                : false
            }
            helperText={
              formik.touched.confirmEmailId && formik.errors.confirmEmailId
                ? formik.errors.confirmEmailId
                : ""
            }
          />
        </div>
        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="Mobile Number" required={true} />
          <InputMask
            mask="0499 999 999"
            value={formik.values.phoneNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.phoneNumber && formik.errors.phoneNumber
                ? true
                : false
            }
            helperText={
              formik.touched.phoneNumber && formik.errors.phoneNumber
                ? formik.errors.phoneNumber
                : ""
            }
          >
            {inputProps => (
              <ICInput
                id="phoneNumber"
                name="phoneNumber"
                label=""
                placeholder="Mobile Number"
                {...inputProps}
              />
            )}
          </InputMask>
        </div>
      </div>

      <div className="row p-4">
        <Label className="gray large ml-3 w-100" title="Address Information" />
        <div className="col-sm-4">
          <Label
            className="gray small"
            title="Unit Number/Street Number"
            required={true}
          />
          <ICInput
            id="streetNumber"
            name="streetNumber"
            label=""
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.streetNumber}
            error={
              formik.touched.streetNumber && formik.errors.streetNumber
                ? true
                : false
            }
            helperText={
              formik.touched.streetNumber && formik.errors.streetNumber
                ? formik.errors.streetNumber
                : ""
            }
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Street Name" required={true} />
          <ICInput
            id="streetName"
            name="streetName"
            label=""
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.streetName}
            error={
              formik.touched.streetName && formik.errors.streetName
                ? true
                : false
            }
            helperText={
              formik.touched.streetName && formik.errors.streetName
                ? formik.errors.streetName
                : ""
            }
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Suburb" required={true} />
          <ICInput
            id="suburb"
            name="suburb"
            label=""
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.suburb}
            error={formik.touched.suburb && formik.errors.suburb ? true : false}
            helperText={
              formik.touched.suburb && formik.errors.suburb
                ? formik.errors.suburb
                : ""
            }
          />
        </div>
        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="State" required={true} />
          <ICSelect
            label=""
            placeholder="Select State"
            id="state"
            name="state"
            items={props.stateList}
            useId="stateId"
            useValue="stateId"
            value={formik.values.state}
            onBlur={formik.handleBlur}
            handleChange={val => {
              formik.values.state = val;
              formik.setFieldValue("state", val);
              formik.handleChange("state");
            }}
            error={formik.touched.state && formik.errors.state ? true : false}
            helperText={
              formik.touched.state && formik.errors.state
                ? formik.errors.state
                : ""
            }
          />
          {formik.errors.state && formik.touched.state ? (
            <Label title="Please select State" className="small error" />
          ) : (
            ""
          )}
        </div>
        <div className="col-sm-6 mt-4 pt-1">
          <Label className="gray small" title="Postcode" required={true} />
          <InputMask
            mask="9999"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.postCode}
            error={
              formik.touched.postCode && formik.errors.postCode ? true : false
            }
            helperText={
              formik.touched.postCode && formik.errors.postCode
                ? formik.errors.postCode
                : ""
            }
          >
            {inputProps => (
              <ICInput
                id="postCode"
                name="postCode"
                label=""
                placeholder=""
                {...inputProps}
              />
            )}
          </InputMask>
        </div>
      </div>

      <div className="row p-4">
        <Label className="gray large ml-3 w-100" title="Upload" />
        <div className="col-sm-6">
          <Label className="gray small w-100" title="Profile Pic" />
          <img
            src={userProfilePic ? userProfilePic : DefaultUserImg}
            alt="ic-user"
            className="user-img rounded-circle float-left"
          />
          <CircularProgress
            color="secondary"
            className={
              userPicLoader ? "primary-loader user-pic-loader" : "d-none"
            }
          />
          <div className="user-picture-div" onClick={handleFileInput}>
            <i className="fas fa-file-upload ic-file-upload-icon mt-2 float-left grey"></i>
            <Label title="Choose File" className="mt-4 choose-file-lbl gray" />
            <Label
              title="JPG, GIF or PNG. Max size of 1MB"
              className="p-0 ex-small clearfix w-100"
            />
            <input
              type="file"
              id="file"
              accept="image/jpeg,image/gif,image/png"
              ref={inputUserProfilePic}
              style={{ display: "none" }}
              onChange={onChangeHandler}
            />
          </div>
        </div>

        <div className="col-sm-6">
          <Label className="gray small w-100" title="Photo ID" />
          <img
            src={userPhotoId ? userPhotoId : NoImg}
            alt="ic-user-id"
            className="user-img rounded float-left"
          />
          <CircularProgress
            color="secondary"
            className={
              userPhotoIdLoader ? "primary-loader user-pic-loader" : "d-none"
            }
          />
          <div className="user-picture-div" onClick={handlePhotoIDFileInput}>
            <i className="fas fa-file-upload ic-file-upload-icon mt-2 float-left grey"></i>
            <Label title="Choose File" className="mt-4 choose-file-lbl gray" />
            <Label
              title="JPG, GIF or PNG. Max size of 1MB"
              className="p-0 ex-small clearfix w-100"
            />
            <input
              type="file"
              id="file"
              accept="image/jpeg,image/gif,image/png"
              ref={inputPhotoId}
              style={{ display: "none" }}
              onChange={onChangePhotoIDHandler}
            />
          </div>
        </div>
      </div>

      <div className="row p-4">
        <div className="col-sm-6">
          <Label
            className="gray small"
            title="Create Password"
            required={true}
          />
          <ICInput
            id="password"
            name="password"
            label=""
            type="password"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            error={
              formik.touched.password && formik.errors.password ? true : false
            }
            helperText={
              formik.touched.password && formik.errors.password
                ? formik.errors.password
                : ""
            }
          />
        </div>
        <div className="col-sm-6">
          <Label
            className="gray small"
            title="Confirm Password"
            required={true}
          />
          <ICInput
            id="confirmPassword"
            name="confirmPassword"
            label=""
            type="password"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirmPassword}
            error={
              formik.touched.confirmPassword && formik.errors.confirmPassword
                ? true
                : false
            }
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
                ? formik.errors.confirmPassword
                : ""
            }
          />
        </div>
      </div>

      <div className={props.form1Filled ? "d-none" : "row mt-4 mb-3"}>
        <div className="col-sm-12 text-center mt-5 ">
          <Button type="submit" className="ml-3" disabled={signUpBtnDisable} />
        </div>
      </div>
    </form>
  );
};

// export default DoctorSignUp;

const mapStateToProps = props => ({
  userSubscribed: props.commonReducers
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DoctorSignUp);

DoctorSignUp.defaultProps = {
  serverErrorMsg: ""
};

DoctorSignUp.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  errorFileUpload: PropTypes.func
};
